import * as Yup from 'yup'
import {amountSchema, currencySchema, priceSchema} from 'utils/form'

export const CONTRIBUTIONS_COUNT_LIMIT = 12
export const POLICY_TYPES = [{id: 'OCP', label: 'OCP'}, {id: 'OCS', label: 'OCS'}, {id: 'OCP_OCS', label: 'OCP/OCS'}]

function checkPolicyType(policyValue, policyCheck) {
  return policyValue?.includes(policyCheck)
}

export function hasOCP(policyValue) {
  return checkPolicyType(policyValue, 'OCP')
}

export function hasOCS(policyValue) {
  return checkPolicyType(policyValue, 'OCS')
}

export const INITIAL_VALUES = {
  number: '',
  type: POLICY_TYPES[0].id,
  ocpAmount: {
    amount: '',
    currencyCode: 'PLN'
  },
  ocsAmount: {
    amount: '',
    currencyCode: 'PLN'
  },
  domestic: false,
  foreign: false,
  dateOfConclusion: null,
  startDate: null,
  endDate: null,
  insurerId: null,
  contributionsDetails: {
    count: 0,
    amount: '',
    ocpAmount: '',
    ocsAmount: '',
    currencyCode: '',
    contributions: []
  },
  filesIds: []
}

export const InsurancePolicySchema = Yup.object().shape({
  number: Yup.string()
    .required('form.validation.required'),
  type: Yup.string(),
  dateOfConclusion: Yup.date()
    .required('form.validation.required'),
  startDate: Yup.date()
    .required('form.validation.required'),
  endDate: Yup.date()
    .required('form.validation.required'),
  ocpAmount: Yup.object().when('type', (type) => {
    if (hasOCP(type)) {
      return priceSchema.required('form.validation.required')
    } else {
      return Yup.object().notRequired().nullable()
    }
  }),
  ocsAmount: Yup.object().when('type', (type) => {
    if (hasOCS(type)) {
      return priceSchema.required('form.validation.required')
    } else {
      return Yup.object().notRequired().nullable()
    }
  }),
  domestic: Yup.bool(),
  foreign: Yup.bool(),
  insurerId: Yup.string()
    .nullable()
    .required('form.validation.required'),
  contributionsDetails: Yup.object().when('type', (type)=>{
    return contributionsDetailsSchema(type)
  }),
  filesIds: Yup.array().of(Yup.string())
})

function contributionsDetailsSchema(policyType){
  return Yup.object().shape({
    count: Yup.number()
      .min(0).max(CONTRIBUTIONS_COUNT_LIMIT),
    ocpAmount: Yup.number().when('type', () => {
      if (hasOCP(policyType)) {
        return amountSchema
      } else {
        return amountSchema.notRequired().nullable()
      }
    }),
    ocsAmount: Yup.number().when('type', () => {
      if (hasOCS(policyType)) {
        return amountSchema
      } else {
        return amountSchema.notRequired().nullable()
      }
    }),
    amount: amountSchema,
    currencyCode: currencySchema,
    contributions: Yup.array().of(
      Yup.object().shape({
        confirmationDate: Yup.date().nullable(),
        paymentDate: Yup.date().nullable(),
        amount: priceSchema,
        isPaid: Yup.bool(),
        ordinalNumber: Yup.number()
      }))
  })
}

export function toFormValues(insurancePolicy) {
  const {
    number,
    type,
    ocpAmount,
    ocsAmount,
    domestic,
    foreign,
    dateOfConclusion,
    startDate,
    endDate,
    insurerId,
    contributionsDetails,
    files
  } = insurancePolicy
  return ({
    number,
    type,
    ocpAmount,
    ocsAmount,
    domestic,
    foreign,
    dateOfConclusion,
    startDate,
    endDate,
    insurerId,
    contributionsDetails,
    filesIds: files?.map(file => file.id) || []
  })
}
